import { Navigate } from 'react-router-dom';
import React from 'react';
import { SyncRoute } from './type';
// import { rootLoader } from './loader';

// path配置时最好使用完整路径
export const routes: SyncRoute[] = [
  {
    path: '/',
    root: true,
    component: React.lazy(() => import('@/App')),
    children: [
      {
        path: '',
        element: <Navigate to="/index" />,
      },
      {
        path: '/index',
        component: React.lazy(() => import('@/pages/index')),
      },
      {
        path: '/create',
        component: React.lazy(() => import('@/pages/create')),
      },
      {
        path: '/create/:id',
        component: React.lazy(() => import('@/pages/create')),
      },
      {
        path: '/scgl',
        component: React.lazy(() => import('@/pages/MaterialsManage')),
      },
      {
        path: '/plan',
        component: React.lazy(() => import('@/pages/plans')),
      },
      {
        path: '/set',
        component: React.lazy(() => import('@/pages/SetInfos')),
      },
      {
        path: '/users',
        component: React.lazy(() => import('@/pages/userInfos')),
      },
      {
        path: '/zhzj',
        component: React.lazy(() => import('@/pages/AccountFunds')),
      },
      {
        path: '/sjtj',
        component: React.lazy(() => import('@/pages/DataCount')),
      }
    ]
  },
  {
    path: '/login',
    component: React.lazy(() => import('@/pages/login')),
  },
  {
    path: '/agree',
    component: React.lazy(() => import('@/pages/agree')),
  },
];
